import ProtectedRouter from "@/context/auth/ProtectedRouter";
import { TenantProvider } from "@/context/TenantContext";
import { useTenant } from "@/context/useTenant";
import MainLayout from "@/layouts/MainLayout";
import StarterLayout from "@/layouts/StarterLayout";
import NotFoundPage from "@/pages/NotFoundPage";
import routes from "@/utils/routes";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

function App() {
  return (
    <TenantProvider>
      <AppWithRouter />
    </TenantProvider>
  );
}

const AppWithRouter = () => {
  const { tenantId, isAtRoot } = useTenant();

  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

  const jainElibraryRoute = publicRoutes.find(
    r => r.path === "/jainelibrary-admin"
  );
  const otherPublicRoutes = publicRoutes.filter(
    r => r.path !== "/jainelibrary-admin"
  );

  const basename = isAtRoot ? "" : `/${tenantId}`;

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route element={<TopLevelComponent />}>
          {!isAtRoot &&
            otherPublicRoutes.map(({ path, element: Page }) => (
              <Route key={path} path={path} element={<StarterLayout />}>
                <Route index element={<Page />} />
              </Route>
            ))}

          {jainElibraryRoute &&
            (isAtRoot ? (
              <>
                {/* Redirect legacy /jainelibrary-admin/* URLs to /* */}
                <Route
                  path="jainelibrary-admin/*"
                  element={<RedirectFromLegacyAdminPath />}
                />
                <Route index element={<jainElibraryRoute.element />} />
                <Route path="*" element={<jainElibraryRoute.element />} />
              </>
            ) : (
              <Route
                path={`${jainElibraryRoute.path}/*`}
                element={<jainElibraryRoute.element />}
              />
            ))}

          {!isAtRoot && (
            <Route element={<ProtectedRouter />}>
              <Route element={<MainLayout />}>
                {authRoutes.map(({ path, element: Page }) => (
                  <Route key={path} path={path} element={<Page />} />
                ))}
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Route>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

const TopLevelComponent = () => {
  return <Outlet />;
};

// When at root, redirect /jainelibrary-admin/* to /* (e.g. /jainelibrary-admin/signup -> /signup)
const RedirectFromLegacyAdminPath = () => {
  const { pathname } = useLocation();
  const newPath = pathname.replace("/jainelibrary-admin", "") || "/";
  return <Navigate to={newPath} replace />;
};

export default App;
